enum MIDDLE_PANEL_TAB_NAMES {
  TICKET_DETAILS = 'Ticket Details',
  JOURNEY = 'Journey',
  WORKFLOWS = 'Action Items',
  ATTACHMENTS = 'Attachments',
  RELATED_ITEMS = 'Related Items',
  COMPANY_INFO = 'Help Desk Info',
  COMPANY_TICKETS = 'Company Tickets',
}

export { MIDDLE_PANEL_TAB_NAMES };
